import angular from 'angular';

export default angular.module('services.lazyLoadingDirective', [])
  .directive('lazySrc', () => {
    'ngInject';

    return {
      controller: 'lazyLoadingController',
      restrict: 'A',
    };
  })
  .controller('lazyLoadingController', ($scope, $rootScope, $element: JQLite, usersService, $attrs) => {
    'ngInject';

    const preloadImage = (entry: IntersectionObserverEntry) => {
      const image = entry.target as HTMLImageElement;

      image.src = $attrs.lazySrc;
    };

    const lazyLoadingObserver = new IntersectionObserver((entries, self) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          preloadImage(entry as any);
          self.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px',
      threshold: 0,
    });

    const init = () => {
      $element.addClass('preview');
      lazyLoadingObserver.observe($element[0]);
    };

    init();
  })
  .name;
